var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16797 6.66797C3.16797 5.6071 3.5894 4.58969 4.33954 3.83954C5.08969 3.0894 6.1071 2.66797 7.16797 2.66797H15.3973C16.4576 2.66855 17.4743 3.0901 18.224 3.83997L28.8906 14.5066C29.6405 15.2567 30.0618 16.274 30.0618 17.3346C30.0618 18.3953 29.6405 19.4125 28.8906 20.1626L20.664 28.392C20.2925 28.7635 19.8515 29.0582 19.3662 29.2592C18.8808 29.4603 18.3606 29.5638 17.8353 29.5638C17.31 29.5638 16.7898 29.4603 16.3044 29.2592C15.8191 29.0582 15.3781 28.7635 15.0066 28.392L4.33997 17.7253C3.58977 16.9753 3.1682 15.9581 3.16797 14.8973V6.66797ZM9.83463 8.0013C9.48101 8.0013 9.14187 8.14178 8.89183 8.39183C8.64178 8.64188 8.5013 8.98101 8.5013 9.33464C8.5013 9.68826 8.64178 10.0274 8.89183 10.2774C9.14187 10.5275 9.48101 10.668 9.83463 10.668C10.1883 10.668 10.5287 10.5275 10.7788 10.2774C11.0288 10.0274 11.1693 9.68826 11.1693 9.33464C11.1693 8.98101 11.0288 8.64188 10.7788 8.39183C10.5287 8.14178 10.1883 8.0013 9.83463 8.0013Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.0bc90ab3b0393cbc48712e01204f211e.svg";
export { ForwardRef as ReactComponent };